import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanesProvider, PlanHtml, ProyectQr, Plan } from '../../../providers/planes';
import { User, UserHtml, UserDb } from '../../../providers/user';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Utils } from '../../../providers/utils';
import { AuthProvider } from '../../../providers/auth';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NotificacionesProvider, NotyPlan } from '../../../providers/notificaciones';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {

    user: UserDb = new UserDb();
    oldUser: UserDb = new UserDb();
    planesUser: Plan[] = [];
    planes: Plan[] = [];
    notyPlanes: NotyPlan[] = [];
    editData: boolean = false;

    private _successData = new Subject<{ message: string, type: string }>();
    private _successPass = new Subject<{ message: string, type: string }>();
    alertData: {
        message: string,
        type: string
    } = {
            message: '',
            type: 'success'
        }
    alertPass: {
        message: string,
        type: string
    } = {
            message: null,
            type: 'danger'
        }

    activateSubmit: boolean = false;

    oldPass: string = '';
    newPass: string = '';
    passChangeEdit: string = '';

    @ViewChild('contentModalContractPlan') contentModalContractPlan;
    modalContractPlan: NgbModalRef;
    modalContractPlanCloseResult: string;

    constructor(private navParams: ActivatedRoute, public modalService: NgbModal, private _auth: AuthProvider, private _notys: NotificacionesProvider, private _planes: PlanesProvider, public toastr: ToastsManager, public vcr: ViewContainerRef, private _user: User, private _utils: Utils) {
        this.toastr.setRootViewContainerRef(vcr);
        this.editData = this._auth.userLoggend.id == this.navParams.snapshot.paramMap.get('id');
        this._user.find(this.navParams.snapshot.paramMap.get('id')).then(user => {
            this.user = user;
            this.oldUser = new UserDb(this.user);
            this._planes.all().then(planes => {
                this.planes = planes;
                return planes;
            }).then(planes => {
                let pls: Plan[] = [];
                user.planes.forEach(p => {
                    let plan = planes.filter(plan => plan.id == p);
                    pls.push(plan[0]);
                });
                this.planesUser = pls;
                this._notys.findPlanesByUser(this.user.id).then(np => {
                    this.notyPlanes = np;
                });
            });
        });
    }

    aceptarNotyPlan(notyPlan: NotyPlan) {
        let newProyects: ProyectQr[] = [];
        for (let i = 0; i < notyPlan.plan.numProyects; i++) {
            let pQr = new ProyectQr();
            pQr.name += ' ' + (this.user.codigosQr.length + i + 1);
            pQr.carpetas[0].name = 'Default 1';
            this._planes.storeQr(this.user.id, pQr).then(nQr => {
                this.user.codigosQr.push(nQr);
                newProyects.push(nQr);
                if (notyPlan.plan.numProyects == newProyects.length) {
                    // guardar plan nuevo (solo es la key del plan) y proyectos en el usuario
                    this.user.planes.push(notyPlan.plan.id);
                    this._user.update(this.user).then(_ => {
                        // borrar noty plan
                        this._notys.deletePlan(notyPlan).then(r => {
                            this.notyPlanes = this.notyPlanes.filter(n => n.id != notyPlan.id);
                            let plan = this.planes.filter(plan => plan.id == notyPlan.plan.id);
                            this.planesUser.push(plan[0]);
                            console.log(this.user, this.planesUser);
                            this.toastr.success('Se ha añadido el nuevo plan al usuario');
                        });
                    });
                }
            });
        }
    }

    cancelarNotyPlan(notyPlan: NotyPlan) {
        this._notys.deletePlan(notyPlan).then(r => {
            this.notyPlanes = this.notyPlanes.filter(n => n.id != notyPlan.id);
            this.toastr.success('Se ha cancelado la solicitud.');
        });
    }

    changeDataUser() {
        if (this.user.domicilio != this.oldUser.domicilio || this.user.name != this.oldUser.name || this.user.nifCif != this.oldUser.nifCif || this.user.telefono != this.oldUser.telefono) {
            if (this.user.domicilio == '' || this.user.name == '' || this.user.nifCif == '' || this.user.telefono == '') {
                this._successData.next({ message: 'rellene correctamente los campos', type: 'danger' });
                return true;
            }

            if (this.user.name.length < 4) {
                this._successData.next({ message: 'minimo 3 caracteres en el campo nombre', type: 'danger' });
                return true;
            }

            if (!this._utils.checkTelefono(this.user.telefono)) {
                this._successData.next({ message: 'rellene el campo telefono correctamente', type: 'danger' });
                return true;
            }

            if (!this._utils.checkNifCif(this.user.nifCif)) {
                this._successData.next({ message: 'rellene el campo nif/cif correctamente', type: 'danger' });
                return true;
            }

            this._user.update(this.user).then(_ => {
                this._successData.next({ message: 'Perfil actualizado correctamente', type: 'success' });
            });
        }/* else{
            // this._success.next({message: 'no se han cambiado los datos', type: 'success'});
            this._success.next({message: 'checkNifCif ' + this._utils.checkNifCif(this.user.nifCif), type: 'success'});
        } */
    }

    changeProyectosEdit() {
        if (this.passChangeEdit !== this.user.proyectosEditPass) {
            this._successPass.next({ message: 'La contraseña es incorrecta', type: 'danger' });
            return true;
        }

        this._user.updateChild(this.user.id, 'proyectosEdit', !this.user.proyectosEdit).then(_ => {
            this.passChangeEdit = '';
            this.user.proyectosEdit = !this.user.proyectosEdit;
            this._auth.userLoggend.proyectosEdit = this.user.proyectosEdit;
            let message = (this.user.proyectosEdit) ? 'Activado' : 'Desactivado';
            this._successPass.next({ message: `se ha ${message} las edicion de proyectos correctamente`, type: 'success' });
        });
    }

    changeProyectosEditPass() {
        if (this.oldPass != this.user.proyectosEditPass) {
            this._successPass.next({ message: 'La antigua contraseña no es correcta', type: 'danger' });
            return true;
        }

        if (this.newPass == '') {
            this._successPass.next({ message: 'Rellene el campo Nueva contraseña', type: 'danger' });
            return true;
        }

        if (!(/^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{6,16}$/).test(this.newPass)) {
            this._successPass.next({ message: 'La nueva contraseña debe ser entre 6-16 caracteres con minúsculas, mayúsculas y números.', type: 'danger' });
            return true;
        }

        this._user.updateChild(this.user.id, 'proyectosEditPass', this.newPass).then(_ => {
            this.user.proyectosEditPass = this.newPass.slice(0);
            this._auth.userLoggend.proyectosEditPass = this.user.proyectosEditPass;
            this.newPass = '';
            this.oldPass = '';
            this._successPass.next({ message: 'La contraseña se ha cambiado correctamente', type: 'success' });
        });
    }

    contratarPlan(plan: Plan) {
        console.log(plan);
        let noty = new NotyPlan(false, '', plan, this.user);
        this._notys.storeNotyPlan(noty).then(_ => {
            this.notyPlanes.push(noty);
            this.modalContractPlan.close();
            this.toastr.success('Se ha enviado la solicitud al administrador.');
        });
    }

    modalDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    ngOnInit() {
        this._successData.subscribe((alert) => {
            this.alertData.message = alert.message;
            this.alertData.type = alert.type;
        });
        this._successData.pipe(
            debounceTime(5000)
        ).subscribe(() => this.alertData.message = null);

        this._successPass.subscribe((alert) => {
            this.alertPass.message = alert.message;
            this.alertPass.type = alert.type;
        });
        this._successPass.pipe(
            debounceTime(5000)
        ).subscribe(() => this.alertPass.message = null);
    }

    openModalContractPlan() {
        this.modalContractPlan = this.modalService.open(this.contentModalContractPlan, { windowClass: 'intra-modal-lg' });
        this.modalContractPlan.result.then((result) => {
            this.modalContractPlanCloseResult = `Closed with: ${result}`;
        }, (reason) => {
            this.modalContractPlanCloseResult = `Dismissed ${this.modalDismissReason(reason)}`;
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/pages/dash/user/user.component.ts